import { BalanceSheetId, SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { balanceSheetsQueryKey } from "../../financials";

export function useAdminDeleteBalanceSheet(accountId: SuretyAccountId) {
	const { _delete } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: (balanceSheetId: BalanceSheetId) =>
			_delete(
				`/v2/admin/surety/accounts/${accountId}/balance-sheets/${balanceSheetId}`,
				undefined,
				"none",
			),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: balanceSheetsQueryKey(accountId) });
		},
	});

	return {
		deleteBalanceSheet: mutation.mutate,
		deleteBSLoading: mutation.isPending,
		deleteBSError: mutation.error,
		resetDeleteBSError: mutation.reset,
	};
}
